import React from "react";
import { useCookies } from "react-cookie";

function EmployerDashboardTopNav({ screenWidth, headingTitle, setShowSideBar }) {
	const [__, _] = useCookies(["Authorization"]);

	return (
		<div className="rounded-t-2xl border-b border-gray-200 flex items-center justify-between p-4 bg-white w-full h-14">
			{screenWidth <= 768 && (
				<i className="bi bi-list cursor-pointer text-gray-600 text-xl" onClick={() => setShowSideBar(true)} />
			)}
			{screenWidth > 768 && (
				<div className="flex items-center">
					{headingTitle && <div className="text-black text-base font-medium">{headingTitle}</div>}
				</div>
			)}
		</div>
	);
}

export default EmployerDashboardTopNav;
